import type {
  CurrencyAmount,
  IsoDate,
  IsoDateTime,
} from '@omnipresentgroup/design-system';

import type { Country } from '../common';

export enum BenefitOrigin {
  LSP = 'LSP',
  OMNI_ENTITY = 'OMNI_ENTITY',
}

export enum BenefitType {
  ACCIDENT_DEATH_AND_DISABILITY = 'ACCIDENT_DEATH_AND_DISABILITY',
  BENEFITS_CARD = 'BENEFITS_CARD',
  CRITICAL_ILLNESS = 'CRITICAL_ILLNESS',
  DENTAL = 'DENTAL',
  GROUP_LIFE_AND_WORK_INJURY = 'GROUP_LIFE_AND_WORK_INJURY',
  HEALTHCARE = 'HEALTHCARE',
  LIFE_INSURANCE = 'LIFE_INSURANCE',
  LONG_TERM_DISABILITY = 'LONG_TERM_DISABILITY',
  MEAL_BENEFITS = 'MEAL_BENEFITS',
  PENSION = 'PENSION',
  TRANSPORT_BENEFITS = 'TRANSPORT_BENEFITS',
  WAIVER_OF_PREMIUM = 'WAIVER_OF_PREMIUM',
  TRAVEL_INSURANCE = 'TRAVEL_INSURANCE',
}

export enum BenefitPackage {
  BRONZE = 'BRONZE',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  STANDARD = 'STANDARD',
}

export type BenefitPensionAmount = {
  employerAmount: CurrencyAmount;
  employeeAmount: CurrencyAmount;
  employeeVoluntaryContributionAmount: CurrencyAmount;
};

export type BenefitPensionPercentage = {
  employerPercentage: string;
  employeePercentage: string;
  employeeVoluntaryContributionPercentage: string;
};

export type Benefit = {
  benefitEffectiveDate: IsoDateTime;
  benefitType: BenefitType;
  benefitsCurrency: string;
  clientId: string;
  country: Country;
  employeeExternalId: string;
  employeeId: string;
  employeeName: string;
  employerCost?: CurrencyAmount;
  numberOfDependents: number;
  payrollPeriod: string;
  vendor: string;
  origin: BenefitOrigin;
  lspId?: string;
  coverage?: string;
  employeeDeduction?: CurrencyAmount;
  mandatory?: boolean;
  package?: BenefitPackage;
  pensionDetails?: BenefitPensionAmount | BenefitPensionPercentage;
};

export type Benefits = {
  benefits: Benefit[];
  lastUpdated: IsoDate;
};

export const isBenefitPensionPercentage = (
  benefitPension: Benefit['pensionDetails'],
): benefitPension is BenefitPensionPercentage =>
  (benefitPension as BenefitPensionPercentage)?.employeePercentage !==
  undefined;
/***
 * Domain
 ***/

export type GetBenefitsResponse = Benefits;
